import {
  Container,
  CardContainer,
  CMdExpandMore,
  CardTitle,
  MedicalCard,
  MedicalSearch,
  MedicalTab,
  Table,
} from "../../style/Prescription";
import UpArrow from "../../assets/AssetArrow.png";
import FormControl from "@material-ui/core/FormControl";
import { CustomDiv } from "../../style/shared";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { Button, ButtonGrey } from "../../style/Button";
import { FaRegEdit } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import { Billing } from "../Billing/Billing";
import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";
import Medication from "./Medication";
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import moment from "moment";
import "./select.css";
import { subject } from "../../service";
import { verifyAuth } from "../../authverify";
import { ModalButton } from "../../style/ModalButton";
import TitlDollar from "../../assets/tiltdollar.png";
import TitlDollarGrey from "../../assets/dollargrey_tilt.png";
import { Image2 } from "../../style/Logo";
import styled from "styled-components";
import { CustomLinkBut } from "../../style/Dashboard";
import PrimeraCreative from "../NewCreatives/PrimeraCreative/PrimeraCreative";
import MedizenCreative from "../NewCreatives/MedizenCreative/MedizenCreative";
import { elementAt } from "rxjs";
import PrimeraVerticalAd from "../../assets/Ads/PrimeraV.jpg";
import MedizenVerticalAd from "../../assets/Ads/MedizenV.jpg";

const Card = (props) => {
  return (
    <CardContainer>
      <CardTitle>{props.name}</CardTitle>
      <CMdExpandMore size="25px" />
    </CardContainer>
  );
};
const Paper = styled.div`
  width: 100%;
  min-height: 45px;
  margin-bottom: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border: 1px solid #c5c5c5;
  border-radius: 7px;
  font-size: 13px;
  font-weight: 500;
`;
export class MedicationCard extends React.Component {
  constructor(props) {
    super(props);

    if (!verifyAuth()) {
      this.props.history.push({
        pathname: "/",
      });
    }

    this.state = {
      medicationName: "",
      amount: "",
      dosageForm: "",
      route: "",
      frequency: "",
      patientDirection: "",
      daysSupply: "",
      dispenseAmount: "",
      pharmacyNote: "",
      alternativeMedication: "",
      rows: [],
      medarray: [],
      imageHeader: "Ads/Horizontal2.jpeg",
      imageLeft: "Ads/Vertical.jpeg",
      discount: false,
      price: "",
    };
    //const { setBanner, setSelectedBanner } = this.props;

    let valuee = window.sessionStorage.getItem("keyselected");
    let p0 = new Map();
    p0.set("NA", {
      medicationName: "None",
      amount: "",
      dosageForm: "",
      route: "",
      frequency: "",
      patientDirection: "",
      daysSupply: "",
      dispenseAmount: "",
      pharmacyNote: "",
      alternativeMedication: "",
      imageHeader: "Ads/Horizontal2.jpeg",
      imageLeft: "Ads/Vertical.jpeg",
      discount: false,
      price: "",
    });

    let p1 = new Map();
    p1.set("NA", {
      medicationName: "None",
      amount: "",
      dosageForm: "",
      route: "",
      frequency: "",
      patientDirection: "",
      daysSupply: "",
      dispenseAmount: "",
      pharmacyNote: "",
      alternativeMedication: "",
      imageHeader: "Ads/Horizontal2.jpeg",
      imageLeft: "Ads/Vertical.jpeg",
      discount: false,
      price: "",
    });
    p1.set("mrbcmc", {
      medicationName: "Cyramza",
      amount: "10 mg/mL",
      dosageForm: "Injectible Vial",
      route: "IV",
      frequency: "Weekly",
      patientDirection: "To be administered at the Hospital",
      daysSupply: "7 Weeks - 7 Vials",
      dispenseAmount: "Vial",
      pharmacyNote: "DAW",
      alternativeMedication: "NA",
      imageHeader: "Ads/Horizontal3.jpeg",
      imageLeft: "Ads/Vertical1.jpeg",
      discount: false,
      price: "8.35",
    });
    p1.set("mdbtnc", {
      medicationName: "Taxotere",
      amount: "20 mg/mL",
      dosageForm: "Injectible Vial",
      route: "IV",
      frequency: "Once in 3 Weeks",
      patientDirection: "To be administered at the Hospital",
      daysSupply: "1 Vial",
      dispenseAmount: "Vial",
      pharmacyNote: "DAW",
      alternativeMedication: "NA",
      imageHeader: "Ads/Horizontal3.jpeg",
      imageLeft: "Ads/Vertical.jpeg",
      discount: false,
      price: "11.47",
    });

    let p2 = new Map();
    p2.set("NA", {
      medicationName: "None",
      amount: "",
      dosageForm: "",
      route: "",
      frequency: "",
      patientDirection: "",
      daysSupply: "",
      dispenseAmount: "",
      pharmacyNote: "",
      alternativeMedication: "",
      imageHeader: "Ads/Horizontal2.jpeg",
      imageLeft: "Ads/Vertical.jpeg",
      discount: false,
      price: "13.99",
    });
    p2.set("mfnc6", {
      medicationName: "Favipiravir",
      amount: "NA",
      dosageForm: "Tablets",
      route: "Oral",
      frequency:
        "Day 1 - 1000 mg twice a day (BID), Day 2 - 5 - 400 mg favipiravir twice a day (BID)",
      patientDirection:
        "Self-isolation. Continuous monitoring of Body Temp and SPO2. Follow-up after 5 days",
      daysSupply: "5",
      dispenseAmount: "Favipiravir 400 mg - 15 Tablets ",
      pharmacyNote: "NA",
      alternativeMedication: "NA",
      imageHeader: "Ads/Horizontal4.jpeg",
      imageLeft: "Ads/Vertical1.jpeg",
      discount: false,
      price: "7.29",
    });
    p2.set("mdbd6nc", {
      medicationName: "Decadron 6mg",
      amount: "NA",
      dosageForm: "Tablet",
      route: "Oral",
      frequency: "Once Daily (OD)",
      patientDirection:
        "Discontinue if your blood glucose levels are >300mg/dL, and see your Physician",
      daysSupply: "10",
      dispenseAmount: "Decadron 6 mg - 10 Tablets",
      pharmacyNote: "DAW",
      alternativeMedication: "NA",
      imageHeader: "Ads/Horizontal5.jpeg",
      imageLeft: "Ads/Vertical.jpeg",
      discount: false,
      price: "6.85",
    });

    let p3 = new Map();
    p3.set("NA", {
      medicationName: "None",
      amount: "",
      dosageForm: "",
      route: "",
      frequency: "",
      patientDirection: "",
      daysSupply: "",
      dispenseAmount: "",
      pharmacyNote: "",
      alternativeMedication: "",
      imageHeader: "Ads/Horizontal2.jpeg",
      // imageHeader: <PrimeraCreative />,
      imageLeft: "Ads/Vertical.jpeg",
      discount: false,
      price: "",
    });
    p3.set("mpbl5m", {
      medicationName: "Medizen",
      amount: "NA",
      dosageForm: "",
      route: "Tablet",
      frequency: "Twice a day",
      patientDirection: "1st dose upon waking up 2nd dose after 8 hours",
      daysSupply: "30",
      dispenseAmount: "50 Tablet",
      pharmacyNote: "60mg/day, 2 tab/day only",
      alternativeMedication: "Neurontin",
      imageHeader: "Ads/Horizontal1.jpeg",
      imageLeft: "Ads/Vertical1.jpeg",
      discount: true,
      price: "9.33",
    });
    p3.set("migblnc0", {
      medicationName: "Primera",
      amount: "NA",
      dosageForm: "Injection",
      route: "Infusion",
      frequency: "Once a week",
      patientDirection:
        "To be taken post-meal before sleeping. Keep hard candies handy",
      daysSupply: "",
      dispenseAmount: "10 injections",
      pharmacyNote:
        "2.5 mg once weekly for 4 weeks, Continue to 5mg once weekly for at least 4 weeks",
      alternativeMedication: "NA",
      imageHeader: "Ads/Horizontal5.jpeg",
      imageLeft: "Ads/Vertical.jpeg",
      discount: true,
      price: "8.78",
    });

    let cMap = new Map();
    cMap.set(0, p3);
    cMap.set(1, p3);
    cMap.set(2, p3);
    cMap.set(3, p3);
    cMap.set(4, p3);

    if (!valuee) valuee = 0;

    this.datasets = cMap.get(parseInt(valuee));

    this.sendMessage = this.sendMessage.bind(this);
    this.createRows = this.createRows.bind(this);
    this.restoreRows = this.restoreRows.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.renderview = this.renderview.bind(this);
    this.restoreRows();
    this.renderview();
  }

  handleChange = (event) => {
    if (event.target.value == "mpbl5m") {
      // this.props.setSelectedBanner(<PrimeraCreative />);
      this.props.setSelectedBanner(MedizenVerticalAd);
      window.sessionStorage.setItem("rValue", 1);
    } else if (event.target.value == "migblnc0") {
      this.props.setSelectedBanner(PrimeraVerticalAd);
      window.sessionStorage.setItem("rValue", 2);
    }

    let dataset = this.datasets.get(event.target.value);

    if (dataset) {
      this.state.medicationName = dataset.medicationName;
      this.state.amount = dataset.amount;
      this.state.dosageForm = dataset.dosageForm;
      this.state.route = dataset.route;
      this.state.frequency = dataset.frequency;
      this.state.patientDirection = dataset.patientDirection;
      this.state.daysSupply = dataset.daysSupply;
      this.state.dispenseAmount = dataset.dispenseAmount;
      this.state.pharmacyNote = dataset.pharmacyNote;
      this.state.alternativeMedication = dataset.alternativeMedication;
      this.state.imageHeader = dataset.imageHeader;
      this.state.imageLeft = dataset.imageLeft;
      this.state.discount = dataset.discount;
      this.state.price = dataset.price;
    }

    this.forceUpdate();
    this.props.onSubmitChild(this.state);
  };

  renderview = () => {
    let rmedval = JSON.parse(window.sessionStorage.getItem("med"));
    if (rmedval) {
      if (this.state.medarray.includes(rmedval) === false) {
        this.state.medarray.push(rmedval);
        window.sessionStorage.setItem(
          "medarray",
          JSON.stringify(this.state.medarray)
        );
        window.sessionStorage.removeItem("med");
      }
      this.sendMessage(rmedval);
    }

    if (this.state.medarray.length > 0) {
      this.state.medarray.forEach((element, index) => {
        this.createRows(element, index);
      });
    }
  };

  sendMessage = (val) => {
    let imagesel = {
      headerImg: val.imageHeader,
      leftImg: val.imageLeft,
      bottomImg: "",
    };

    subject.next(JSON.stringify(imagesel));
  };

  restoreRows() {
    let rowstring = window.sessionStorage.getItem("medarray");
    if (rowstring) {
      this.state.medarray = JSON.parse(rowstring);
      // this.state.medarray.forEach((element) => {
      //   this.createRows(element);
      // });
    }
  }

  removeRow = (index) => {
    const newRows = this.state.rows.filter((row) => row.key != index);
    this.setState({ rows: newRows });
    window.sessionStorage.setItem("medarray", JSON.stringify(newRows));
  };

  createRows = (valuem, index) => {
    var logotag = "";
    if (valuem.discount) {
      logotag = <Image2 src={TitlDollar} alt="logo" />;
    } else {
      logotag = <Image2 src={TitlDollarGrey} alt="logo" />;
    }

    this.state.rows.push(
      <React.Fragment key={index}>
        <tr>
          <td>{moment().format("DD-MMM-YYYY")}</td>
          <td style={{ color: "#4678ED", fontWeight: 500 }}>
            {valuem.medicationName} {logotag}
          </td>
          <td>{valuem.amount}</td>
          <td>0</td>
          <td>Pending</td>
          <td style={{ textAlign: "center" }}>
            <FaRegEdit color="#4678ED" />
          </td>
          <td style={{ textAlign: "center" }}>
            <ImCross onClick={() => this.removeRow(index)} />
          </td>
        </tr>
        <tr>
          <td></td>
          <td
            style={{ maxWidth: "200px", paddingLeft: "25px", color: "#969696" }}
          >
            <b
              style={{
                color: "#606060",
                fontWeight: 500,
                fontFamily:
                  "'Montserrat Medium', 'Open Sans', Helvetica, Arial, sans-serif",
              }}
            >
              Sig:
            </b>{" "}
            {valuem.dosageForm} {valuem.route} {valuem.frequency} <br />
            <b
              style={{
                color: "#606060",
                fontWeight: 500,
                fontFamily:
                  "'Montserrat Medium', 'Open Sans', Helvetica, Arial, sans-serif",
              }}
            >
              Sig:
            </b>{" "}
            {valuem.pharmacyNote} <br />
            QUES: 800-422-4523
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </React.Fragment>
    );
  };

  render() {
   
    return (
      <MedicalCard>
        <div>
          <CustomDiv color="#4678ED" fontWeight="600">
            <h1
              style={{
                fontSize: "15px",
                fontWeight: 600,
                fontFamily:
                  "'Montserrat SemiBold', 'Open Sans', Helvetica, Arial, sans-serif",
                padding: "25px",
                paddingBottom: "0px",
              }}
            >
              Medical Search
            </h1>
          </CustomDiv>

          <MedicalSearch>
            <FormControl
              variant="outlined"
              style={{
                minWidth: "85%",
                maxHeight: "25px",
                marginTop: "10px",
                paddingBottom: "7px",
              }}
            >
              <Select
                className="select1"
                defaultValue={"NA"}
                name="presearch"
                onChange={this.handleChange}
                style={{
                  maxHeight: "25px",
                  fontSize: "12px",
                  fontWeight: 400,
                  color: "grey",
                  paddingBottom: "7px",
                }}
              >
                {[...this.datasets.keys()].map((keey) => (
                  <MenuItem value={keey} style={{ maxHeight: "25px" }}>
                    {this.datasets.get(keey).medicationName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <CustomDiv marginT="3px">
              <Button
                height="fit-content"
                backgroundColor="grey"
                marginL="15px"
                style={{
                  padding: "5px 18px",
                  height: "fit-content",
                  borderRadius: "20px",
                  marginTop: "2px",
                  fontSize: "13px",
                  backgroundImage: "none",
                  backgroundColor: "#D0D2D3",
                  color: "#606060",
                  fontWeight: 600,
                  fontFamily:
                    "'Montserrat SemiBold', 'Open Sans', Helvetica, Arial, sans-serif",
                }}
              >
                Search
              </Button>
              {/* <Button
              height="fit-content"
              padding="5px 20px"
              borderRadius="20px"
              color="black"
              backgroundColor="grey"
              fontSize="14px"
              backgroundImage="none"
              marginL="5px"
              onClick={() => {
                <Billing />;
              }}
            >
              Prescriber’s List
            </Button>*/}
            </CustomDiv>
          </MedicalSearch>
        </div>
        <MedicalTab>Pending Medication</MedicalTab>
        <div style={{ overflow: "auto" }}>
          <Table>
            <tr>
              <th>Date Created</th>
              <th>Medication</th>
              <th>Amount</th>
              <th>Refills</th>
              <th>Status</th>
              <th style={{ textAlign: "center" }}>Edit</th>
              <th style={{ textAlign: "center" }}>Remove</th>
            </tr>

            {this.state.rows.map((name) => name)}
          </Table>

          {/* <div >
            <Button
              style={{
                float: 'right', marginLeft: '5px', marginRight: '15px',
                padding: "5px 47px",
                height: "fit-content",
                borderRadius: "20px",
                marginTop: "2px",
                fontSize: "13.5px",
                backgroundImage: "none",
                backgroundColor: "#D0D2D3",
                color: "#606060",
                fontWeight: 600,
                fontFamily: "Montserrat SemiBold, 'Open Sans', Helvetica, Arial, sans-serif",
              }}
            >
              Close
            </Button>
            <Button
              style={{
                float: 'right',
                padding: "5px 20px",
                height: "fit-content",
                borderRadius: "20px",
                marginTop: "2px",
                fontSize: "13.5px",
                backgroundImage: "none",
                backgroundColor: "#D0D2D3",
                color: "#606060",
                fontWeight: 600,
                fontFamily: "Montserrat SemiBold, 'Open Sans', Helvetica, Arial, sans-serif",
              }}
              onClick={() => {
                this.props.history.push({
                  pathname: "/People/Pharmacy",
                  //state: value,
                });
              }}
            >
              Process Medications
            </Button>

          </div> */}
        </div>
        <br />
      </MedicalCard>
    );
  }
}
export class Prescription extends React.Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    //const history = useHistory();
    this.state = { imgsrc: "Ads/Vertical.jpeg" };
    // this.handleOnClick = this.handleOnClick.bind(this);
    this.handleOnClickMed = this.handleOnClickMed.bind(this);

    let rmedval = JSON.parse(window.sessionStorage.getItem("med"));

    if (rmedval) this.state.imgsrc = rmedval.imageLeft;
  }

  // componentDidMount(){
  //   this.subscription = subject.subscribe(res => {
  //     //alert(JSON.parse(res).leftImg);
  //      this.state.imgsrc = JSON.parse(res).leftImg;
  //      //alert(this.state.imgsrc);
  //      this.forceUpdate();
  //   })
  // }

  // componentWillUnmunt(){
  //   this.subscription.unsubscribe();
  // }

  logChildValue = (value) => {
    this.props.history.push({
      pathname: "/People/billing",
      state: value,
    });
  };

  handleOnClickMed = () => {
    this.props.history.push({
      pathname: "/People/Pharmacy",
      //state: value,
    });
  };
  render() {
    const { match, location, history } = this.props;
    const randValue = parseInt(window.sessionStorage.getItem("rValue"));
    return (
      <>
        <Container>
          <div>
            <Paper
              style={{
                color: "#4678ED",
                fontWeight: 600,
                fontSize: "15px",
                fontFamily:
                  "Montserrat SemiBold, 'Open Sans', Helvetica, Arial, sans-serif",
                maxWidth: "100%",
                width: "100%",
                padding: "0px 50px 0px 50px",
              }}
            >
              New Medication{" "}
              <img
                src={UpArrow}
                style={{
                  marginLeft: "auto",
                  marginTop: "0px",
                  width: "13.5px",
                }}
              />
            </Paper>
            <Paper
              style={{
                color: "#606060",
                fontSize: "15px",
                fontWeight: 600,
                fontFamily:
                  "Montserrat SemiBold, 'Open Sans', Helvetica, Arial, sans-serif",
                maxWidth: "100%",
                width: "100%",
                padding: "0px 50px 0px 50px",
              }}
            >
              Medication history{" "}
              <img
                src={UpArrow}
                style={{
                  marginLeft: "auto",
                  marginTop: "0px",
                  width: "13.5px",
                  transform: "rotate(180deg)",
                }}
              />
            </Paper>
            <div style={{width:"309px",marginLeft:"-9px"}}>
              <iframe
                key={randValue}
                style={{ height: "300px", width: "100%" }}
                srcDoc={this.props.reactCreative}
              />
            </div>
          </div>

          <div>
            <MedicationCard
              onSubmitChild={this.logChildValue}
              history={history}
              setBanner={this.props.selectedBanner}
              setSelectedBanner={this.props.setSelectedBanner}
            />
            <CustomLinkBut
              style={{ marginBottom: "20px", marginTop: "40px" }}
              className="button"
              to="/People/Pharmacy"
            >
              Next
            </CustomLinkBut>
          </div>
        </Container>
      </>
    );
  }
}
